module.exports = __webpack_public_path__ + "static/media/street-view.d2704f54.ico";